var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMakerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194 194",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maker logo-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #7f8183 } \n\t\t.s1 { fill: none;stroke: #fefefe;stroke-linecap: round;stroke-linejoin: round;stroke-width: 6 } \n\t\t.s2 { fill: none;stroke: #fefefe;stroke-width: 6 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m0.4 97c0-53 43.3-96.3 96.3-96.3 53 0 96.3 43.3 96.3 96.3 0 53-43.3 96.3-96.3 96.3-53 0-96.3-43.3-96.3-96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m61.9 124.3v-58.3l35 60.6 34.6-60v59.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m67.7 74.9c0-3.6 6.6-6.5 14.7-6.5 8.1 0 14.7 2.9 14.7 6.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m97.1 74.9c0-3.6 6.6-6.5 14.7-6.5 8.1 0 14.7 2.9 14.7 6.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m81.7 100.1h30.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakerLogo);
export default __webpack_public_path__ + "static/media/makerLogo.cbcc79059bd01128d45647d5961a8532.svg";
export { ForwardRef as ReactComponent };